module.exports = __webpack_public_path__ + "img/btn_cancel3_hdtool.7e9dc739.png";